// GENERATED from backend/i18n_pages.py by backend/tests/gen_en_client.py — do not edit.
const data = {
  "about": {
    "kicker": "Who We Are",
    "h1": "Your gateway to global business freedom.",
    "lead": "UNICORP Services Limited helps entrepreneurs and companies expand beyond borders. From offshore incorporation and international banking to accounting, tax and compliance, we simplify the complex so you can focus on building.",
    "imgAlt": "UNICORP team",
    "h2": "Real strategy. Real results.",
    "body": "Expanding into global markets offers major advantages — access to new customers, credibility and international reach. It also brings unfamiliar legal and cultural terrain. Our consultants align every step with your business goals so the process feels effortless and high-end.",
    "v1t": "Transparent pricing",
    "v1b": "All-inclusive fees quoted up front — packages cover government, registry and standard third-party set-up charges, with no hidden costs.",
    "v2t": "Global expertise",
    "v2b": "Local specialists across our supported jurisdictions handle every filing for you.",
    "v3t": "Accountable delivery",
    "v3b": "A specialist owns your case from kickoff to delivery, with clear scope and status updates.",
    "v4t": "Founder-first",
    "v4b": "A dedicated specialist owns your case so you always have a clear point of contact.",
    "ctaTitle": "Ready to expand beyond borders?",
    "cta": "Incorporate now",
    "seoTitle": "About UNICORP | Global Corporate Services",
    "seoDesc": "UNICORP Services Limited helps entrepreneurs expand beyond borders — offshore incorporation, international banking, accounting, tax and compliance."
  },
  "compare": {
    "kicker": "Compare jurisdictions",
    "h1": "Find the right country, side by side.",
    "lead": "Compare set-up fees, annual renewals, delivery timelines and banking options across up to four jurisdictions at once.",
    "aiBtn": "Not sure? Let AI recommend",
    "seoTitle": "Compare Jurisdictions — Fees, Timelines & Banking | UNICORP",
    "seoDesc": "Compare company formation across jurisdictions side by side — set-up fees, annual renewals, delivery timelines and banking options. Pick the right country with UNICORP."
  },
  "bankCompare": {
    "kicker": "Compare banks",
    "h1": "Pick the right bank, side by side.",
    "lead": "Compare support fees, account type, currencies and supported jurisdictions across up to three banks at once.",
    "browse": "Browse all banks",
    "seoTitle": "Compare Corporate Banks — Fees & Currencies | UNICORP",
    "seoDesc": "Compare corporate banks side by side — support fees, account type, currencies and supported jurisdictions. Open your account remotely with UNICORP."
  },
  "cmp": {
    "lowest": "Lowest",
    "customQuote": "Custom quotation",
    "perYear": "/yr",
    "tbc": "To be confirmed",
    "bankOne": "{{count}} bank",
    "bankMany": "{{count}} banks",
    "comparing": "Comparing {{n}} of {{max}}",
    "addCountry": "Add a country",
    "addBank": "Add a bank",
    "reset": "Reset",
    "remove": "Remove {{name}}",
    "popular": "Popular",
    "start": "Start",
    "order": "Order",
    "viewDetails": "View details",
    "details": "Details",
    "scopeNote": "Starting totals are all-inclusive in USD (government & registry fees included). Quotation-only jurisdictions are shown as \"Custom quotation\" and excluded from the \"Lowest\" badge.",
    "openFull": "Open full comparison tool",
    "openFullBank": "Open full bank comparison",
    "typeDigital": "Digital",
    "typeTraditional": "Traditional",
    "pkg": {
      "compare": "Compare",
      "popular": "Most popular",
      "annual": "Annual renewal",
      "readyIn": "Ready in {{t}}",
      "tlAfterReview": "Timeline confirmed after review",
      "selected": "Selected",
      "choose": "Choose plan",
      "start": "Start application"
    },
    "bill": {
      "one-time": "One-time fee",
      "monthly": "Monthly fee",
      "annual": "Annual fee",
      "per-filing": "Per filing",
      "custom": "Custom quotation"
    },
    "suf": {
      "monthly": "/month",
      "annual": "/yr",
      "per-filing": " per filing",
      "one-time": "one-time"
    },
    "f": {
      "setup_fee": "Set-up fee",
      "annual_fee": "Annual renewal",
      "timeline": "Delivery time",
      "bank_count": "Banking options",
      "min_capital": "Min. capital",
      "tax_rate": "Tax rate",
      "corporate_tax": "Corporate tax",
      "vat_gst": "VAT / GST",
      "privacy_level": "Privacy",
      "asset_protection": "Asset protection",
      "legal_system": "Legal system",
      "fee": "Support fee",
      "type": "Account type",
      "currencies": "Currencies",
      "country_count": "Available in",
      "min_balance": "Min. balance",
      "online_banking": "Online banking",
      "multi_currency": "Multi-currency",
      "time_to_open": "Time to open"
    }
  },
  "catalog": {
    "kicker": "Company Formation",
    "h1": "Choose the package that fits your ambition.",
    "lead": "We assist clients with company incorporation across supported jurisdictions — transparent pricing, availability and requirements may vary by jurisdiction. Not sure which to pick?",
    "aiBtn": "Let AI recommend for me",
    "compareBtn": "Compare countries",
    "search": "Search countries or services…",
    "cat": {
      "All": "All",
      "Incorporation": "Incorporation",
      "Banking": "Banking",
      "Compliance": "Compliance"
    },
    "region": "Region",
    "allRegions": "All regions",
    "tickCompare": "Tick <b>Compare</b> on any country to line them up side by side.",
    "noResults": "No results match your search. Try a different keyword or region.",
    "compareKicker": "Compare jurisdictions",
    "compareH2": "See fees & timelines side by side.",
    "max4": "You can compare up to 4 countries at once.",
    "compareN": "Compare {{n}}",
    "seoTitle": "Company Formation | Global Incorporation | UNICORP",
    "seoDesc": "We assist clients with company formation across leading onshore and offshore jurisdictions. Transparent pricing; availability and requirements may vary by jurisdiction.",
    "seoRegionTitle": "Company Formation in {{region}} | International Corporate Services | UNICORP",
    "seoRegionDesc": "Explore company formation options across {{region}}. UNICORP Services Limited provides independent corporate services assistance for clients considering incorporation in applicable jurisdictions."
  },
  "banksPg": {
    "kicker": "Corporate banking",
    "h1": "Open a business account — with or without a company.",
    "lead": "Order a corporate account on its own, fully managed and remote. Tick <b>Compare</b> to line up banks side by side.",
    "compareBtn": "Compare banks",
    "search": "Search banks by name…",
    "type": "Type",
    "all": "All",
    "groupDigital": "Fintech & EMI accounts",
    "groupTraditional": "Traditional banks",
    "compare": "Compare",
    "fintech": "Fintech",
    "bank": "Bank",
    "jurOne": "{{count}} jurisdiction",
    "jurMany": "{{count}} jurisdictions",
    "supportFee": "support fee",
    "order": "Order",
    "details": "Details",
    "payTitle": "Accepting payments, not just banking?",
    "payBody": "If you need to accept card or online payments, see our payment gateway selection, merchant onboarding and integration support.",
    "payBtn": "Payment Solutions",
    "compareN": "Compare {{n}}",
    "seoTitle": "Corporate Bank Accounts — Open Remotely | UNICORP",
    "seoDesc": "Open a corporate bank account remotely with UNICORP. Compare digital and traditional banks across jurisdictions — no incorporation required."
  },
  "advisor": {
    "kicker": "AI advisor",
    "h1": "Describe your business. Get the perfect package.",
    "lead": "Our AI advisor reads your goals and matches you to the ideal incorporation or compliance plan — with a clear reason why.",
    "placeholder": "e.g. I'm launching a SaaS company and want to incorporate in the US and open a business bank account…",
    "ex1": "I'm a US freelancer wanting to open a company to bill international clients.",
    "ex2": "We're a fintech startup that needs a Singapore entity plus a corporate bank account.",
    "ex3": "I run an existing LLC and just need bookkeeping and annual tax filing handled.",
    "tooShort": "Tell us a bit more about your business (at least a sentence).",
    "unavailable": "The advisor is unavailable right now. Please try again.",
    "analysing": "Analysing your business…",
    "submit": "Recommend my package",
    "recommended": "Recommended for you",
    "startThis": "Start this",
    "alsoConsider": "Also consider"
  },
  "studio": {
    "kicker": "UNICORP Digital Studio",
    "h1": "Build your digital business.",
    "lead": "Website. Mobile app. SaaS. Custom platform. Tell us what you're building and get a transparent estimate — then check out or request a tailored quote.",
    "s1": "What do you want to build?",
    "s2": "What features do you need?",
    "s3": "Budget & timeline",
    "grp0": "Website",
    "grp1": "Mobile",
    "grp2": "Web Application",
    "grp3": "Custom",
    "type": {
      "business_website": "Business Website",
      "corporate_website": "Corporate Website",
      "premium_website": "Premium Website",
      "ecommerce_website": "E-commerce Website",
      "landing_page": "Landing Page",
      "website_redesign": "Website Redesign",
      "android_app": "Android App",
      "ios_app": "iOS App",
      "cross_platform_app": "Cross-Platform App",
      "mobile_mvp": "Mobile MVP",
      "web_application": "Web Application",
      "customer_portal": "Customer Portal",
      "admin_dashboard": "Admin Dashboard",
      "saas_mvp": "SaaS MVP",
      "marketplace": "Marketplace",
      "custom_software": "Custom Software"
    },
    "feat": {
      "cms": "CMS",
      "admin_panel": "Admin Panel",
      "user_login": "User Login",
      "payment": "Payment",
      "api": "API",
      "database": "Database",
      "ai": "AI Integration",
      "ecommerce": "E-commerce",
      "notifications": "Notifications",
      "analytics": "Analytics"
    },
    "tl0": "Flexible",
    "tl1": "1–2 months",
    "tl2": "2–3 months",
    "tl3": "3+ months",
    "from": "from {{amount}}",
    "quote": "quote",
    "next": "Next",
    "budget": "Budget",
    "timeline": "Timeline",
    "estimate": "Your estimate",
    "pick": "Pick what you want to build to see a transparent estimate.",
    "initial": "Initial estimate, not a final quotation.",
    "checkout": "Proceed to Checkout",
    "prefer": "Prefer a tailored quote?",
    "name": "Name",
    "email": "Email",
    "anything": "Anything specific?",
    "send": "Request Custom Quote",
    "chooseType": "Choose what you want to build.",
    "signIn": "Please sign in to continue to checkout.",
    "checkoutErr": "Could not start checkout.",
    "nameEmail": "Add your name and a valid email.",
    "sent": "Request sent — our team will be in touch.",
    "sendErr": "Could not send request."
  }
};
export default data;
